// ABOUTME: Smart wrapper for the Delivery Window entity — owns useDeliveryWindowEntity and reports state via context.
// ABOUTME: Renders skeleton/error/form so the page no longer branches per entity.
import React from 'react'

import {useDeliveryWindowEntity} from '../hooks/useDeliveryWindowEntity'
import {useEntityFormContext, useRegisterEntityForm} from '../context/EntityFormContext'
import {DeliveryWindowForm} from './DeliveryWindowForm'
import {EntityContentEmpty} from './EntityContentEmpty'
import {EntityContentError} from './EntityContentError'
import {EntityContentSkeleton} from './EntityContentSkeleton'

export const DeliveryWindowEntityForm: React.FC = () => {
  const ctx = useEntityFormContext()
  const {config, isLoading, error, isSaving, actions} = useDeliveryWindowEntity({
    countryId: ctx.countryId,
    businessLine: ctx.businessLine,
    scopeId: ctx.selectedScopeId,
    pendingScope: ctx.pendingScope,
    rootScopeId: ctx.rootScopeId,
  })

  useRegisterEntityForm(actions, isSaving)

  if (isLoading) return <EntityContentSkeleton />
  if (error) return <EntityContentError />
  if (!config) return <EntityContentEmpty />

  return (
    <DeliveryWindowForm
      key={ctx.formResetKey}
      config={config}
      isReadOnly={ctx.isReadOnly}
      isSlotManagementEnabled={ctx.isSlotManagementEnabled}
      isCountryDefault={ctx.isCountryDefault}
      onDirtyChange={ctx.onDirtyChange}
      onValidChange={ctx.onValidChange}
      onValuesChange={actions.handleValuesChange}
      dayCodes={ctx.dayCodes}
    />
  )
}
